/** Shared date formatting for profile timestamps. Stored values are
 * UTC but tz-naive (Python datetime.utcnow().isoformat() has no offset),
 * so we treat a bare timestamp as UTC, then render in the viewer's own
 * timezone. Returns an em dash for missing/invalid values. */

const DASH = "—";

export function toDate(iso?: string | null): Date | null {
  if (!iso) return null;
  const s = /[Z]|[+-]\d\d:?\d\d$/.test(iso) ? iso : `${iso}Z`;
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function fmtDate(iso?: string | null): string {
  const d = toDate(iso);
  return d
    ? d.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
    : DASH;
}

export function fmtDateTime(iso?: string | null): string {
  const d = toDate(iso);
  if (!d) return DASH;
  return (
    d.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }) +
    ", " +
    d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })
  );
}
